import { Application } from '@hotwired/stimulus'
import DecimalInputController       from './decimal_input_controller'
import IncrementDecrementController from './increment_decrement_controller'
import ArticleSearchController      from './article_search_controller'
import TooltipController            from './tooltip_controller'
import PopoverController            from './popover_controller'
import ModalController              from './modal_controller'
import SearchFocusController        from './search_focus_controller'
import BackToTopController          from './back_to_top_controller'
import SubcategoryFilterController  from './subcategory_filter_controller.js'
import SubscriptionToggleController from './subscription_toggle_controller.js'

const application = Application.start()

// Register your controller(s)
application.register('decimal-input',       DecimalInputController)
application.register('increment-decrement', IncrementDecrementController)
application.register('article-search',      ArticleSearchController)
application.register('tooltip',             TooltipController)
application.register('popover',             PopoverController)
application.register('modal',               ModalController)
application.register('search_focus',        SearchFocusController)
application.register('back-to-top',         BackToTopController)
application.register('subcategory-filter',  SubcategoryFilterController)
application.register('subscription-toggle', SubscriptionToggleController)
